export default "__VITE_ASSET__F770hFic__"